export const options = [
    {
        id: 0,
        value: 'series',
        title: 'Séries',
        parameter: 'titleStartsWith',
    },
    {
        id: 1,
        value: 'characters',
        title: 'Personagens',
        parameter: 'nameStartsWith',
    },
    {
        id: 2,
        value: 'creators',
        title: 'Criadores',
        parameter: 'nameStartsWith',
    },
    {
        id: 3,
        value: 'comics',
        title: 'Quadrinhos',
        parameter: 'titleStartsWith',
        default: true,
    },
    {
        id: 4,
        value: 'events',
        title: 'Eventos',
        parameter: 'nameStartsWith',
    },
    {
        id: 5,
        value: 'stories',
        title: 'Histórias',
        parameter: 'titleStartsWith',
    },
];
